import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { cloneElement, isValidElement } from 'react';
import { brand } from '@/commonTypes';

type StatItem = {
  value: string | number;
  label: string;
  icon: React.ReactNode;
  bg: string;
  color: string;
};

type BrandStatsProps = {
  stats: StatItem[];
};

export default function BrandStats({ data }: { data?: brand }) {
  const stats = [
    {
      value: data?.modelsCount,
      label: 'مدل فعال',
      icon: <MainIcons.carIcon />,
      bg: 'var(--tag-bg)',
      color: 'var(--brand-deep)',
    },
    {
      value: data?.founded,
      label: 'سال تأسیس',
      icon: <MainIcons.CalendarIcon />,
      bg: 'var(--bg)',
      color: 'var(--tag-color)',
    },
    {
      value: '۱۴۰+',
      label: 'کشور فروش',
      icon: <MainIcons.GlobeIcon />,
      bg: 'var(--purple-bg)',
      color: 'var(--purple)',
    },
    {
      value: '۴٫۶',
      label: 'رضایت از ۵',
      icon: <MainIcons.gaugeIcon />,
      bg: 'var(--green-bg)',
      color: 'var(--green)',
    },
  ];

  return (
    <div className={`card ${styles.wrapper}`}>
      {stats?.map((item) => (
        <div key={item.label} className={styles.item}>
          <div
            className={styles.icon}
            style={{
              background: item.bg,
              color: item.color,
            }}
          >
            {isValidElement(item.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
              ? cloneElement(item.icon, {
                  fill: item.color,
                  width: '21px',
                  height: '21px',
                })
              : item.icon}
          </div>

          <div>
            <div className={styles.value}>{item.value}</div>
            <div className={styles.label}>{item.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
